import { createFileRoute } from "@tanstack/react-router";
import { loadStandalonePageWithBody } from "~/utils/content-fns";
import { seo, seoLinks } from "~/utils/seo";

export const Route = createFileRoute("/privacy-policy")({
  loader: async () => {
    const page = await loadStandalonePageWithBody({ data: { path: "privacy-policy.md" } });
    return {
      title: (page.title as string) || "Privacy Policy",
      seo_title: page.seo_title as string | undefined,
      seo_description: page.seo_description as string | undefined,
      html: page.html as string,
    };
  },
  head: ({ loaderData }) => ({
    meta: seo({
      title: loaderData?.seo_title || loaderData?.title || "Privacy Policy",
      description: loaderData?.seo_description,
      url: "/privacy-policy",
    }),
    links: seoLinks({ url: "/privacy-policy" }),
  }),
  component: () => {
    const { title, html } = Route.useLoaderData();
    return (
      <article className="mx-auto max-w-3xl px-4 py-16 md:px-8">
        <h1 className="mb-8 text-4xl font-bold text-charcoal">{title}</h1>
        <div className="content" dangerouslySetInnerHTML={{ __html: html }} />
      </article>
    );
  },
});
